<script lang="ts">
	import { Select } from 'flowbite-svelte';
	import { RefsApi } from '$lib/services/refs';
	import type { RefType } from '$lib/types';

	export let selected: number | undefined = undefined;
	export let color: 'red' | 'base' = 'base';

	$: selectClass = {
		red: 'bg-red-50 border-red-500',
		base: 'bg-gray-50 border-gray-300'
	}[color];

	let regions: RefType[];

	(async function getRegions() {
		const { err, refItems } = await RefsApi().getRegions();
		if (err) throw new Error(err);
		if (!refItems) throw new Error('Unexpected server response');
		regions = refItems;
		// selected = 1; // установил дефолтный регион
	})();
</script>

<!-- $$restProps передает все пропсы  переданные из родительского компонента -->
<div class="relative">
	<Select
		{...$$restProps}
		items={regions}
		bind:value={selected}
		class="{$$slots.left ? 'pl-10' : 'pl-2'} {selectClass} {$$props.class}"
	/>
	{#if $$slots.left}
		<div
			class="flex absolute inset-y-0 items-center text-gray-500 left-0 pl-2.5 pointer-events-none"
		>
			<slot name="left" />
		</div>
	{/if}
</div>
